function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "4E256D9A-DA78-43FB-8526-AA7D00DB3F0E");

var _ref3 = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.");

var _ref4 = /*#__PURE__*/React.createElement("defs", null);

var _ref5 = /*#__PURE__*/React.createElement("g", {
  id: "HOME",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "FOOTER_DESKTOP",
  transform: "translate(-1050.000000, -34.000000)",
  fillRule: "nonzero",
  fill: "#FFFFFF"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-48-Copy",
  transform: "translate(1050.000000, 34.000000)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M24.4481395,0.36 L23.6262791,0.684878049 L28.0183721,11.6297561 L9.9772093,11.6297561 L14.3693023,0.684878049 L13.5474419,0.36 L9.0272093,11.6297561 L0.220930233,11.6297561 L0.220930233,19.0931707 L2.59813953,19.0931707 L2.40372093,19.1414634 L6.50418605,35.6443902 L31.495814,35.6443902 L35.5962791,19.1414634 L35.4018605,19.0931707 L37.7790698,19.0931707 L37.7790698,11.6297561 L28.9727907,11.6297561 L24.4481395,0.36 Z M30.802093,34.7619512 L7.19790698,34.7619512 L3.30511628,19.0887805 L34.6993023,19.0887805 L30.802093,34.7619512 Z M36.8953488,18.215122 L1.10465116,18.215122 L1.10465116,12.5078049 L36.8953488,12.5078049 L36.8953488,18.215122 Z",
  id: "Shape"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle-path",
  x: 18.5581395,
  y: 22.8380488,
  width: 1,
  height: 8.8902439
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle-path",
  x: 23.8604651,
  y: 22.8380488,
  width: 1,
  height: 8.8902439
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle-path",
  x: 13.255814,
  y: 22.8380488,
  width: 1,
  height: 8.8902439
}))));

var SvgEroskiCompraOnline = function SvgEroskiCompraOnline(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "38px",
    height: "36px",
    viewBox: "0 0 38 36",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3, _ref4, _ref5);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgEroskiCompraOnline, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/eroski-compra-online.e3a1b14e.svg";
export { ForwardRef as ReactComponent };